module.exports = "/_next/static/images/ef8ec91b1d29870bb06cdaa6f5900532-hero-small.jpg.webp";